function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M21.1628 3.32558C21.1628 2.444 20.8121 1.59749 20.1893 0.973488C19.5653 0.350698 18.7188 0 17.8372 0H3.32558C2.444 0 1.59749 0.350698 0.973488 0.973488C0.350697 1.59749 0 2.444 0 3.32558V22.6744C0 23.556 0.350697 24.4025 0.973488 25.0265C1.59749 25.6493 2.444 26 3.32558 26H17.8372C18.7188 26 19.5653 25.6493 20.1893 25.0265C20.8121 24.4025 21.1628 23.556 21.1628 22.6744V3.32558ZM19.3488 3.32558V22.6744C19.3488 23.0759 19.1892 23.4593 18.9062 23.7434C18.622 24.0264 18.2387 24.186 17.8372 24.186H3.32558C2.92409 24.186 2.54074 24.0264 2.25656 23.7434C1.97358 23.4593 1.81395 23.0759 1.81395 22.6744V3.32558C1.81395 2.92409 1.97358 2.54074 2.25656 2.25656C2.54074 1.97358 2.92409 1.81395 3.32558 1.81395H17.8372C18.2387 1.81395 18.622 1.97358 18.9062 2.25656C19.1892 2.54074 19.3488 2.92409 19.3488 3.32558Z",
  stroke: "#F1F3F6",
  strokeWidth: 0.3
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M6.65103 9.3718C6.65103 9.53868 6.51558 9.67412 6.3487 9.67412H5.1394C4.63875 9.67412 4.23242 10.0804 4.23242 10.5811C4.23242 11.0818 4.63875 11.4881 5.1394 11.4881H6.3487C7.51689 11.4881 8.46498 10.54 8.46498 9.3718C8.46498 8.20361 7.51689 7.25552 6.3487 7.25552C6.18182 7.25552 6.04638 7.12008 6.04638 6.95319C6.04638 6.78631 6.18182 6.65087 6.3487 6.65087H7.558C8.05865 6.65087 8.46498 6.24454 8.46498 5.74389C8.46498 5.24324 8.05865 4.83691 7.558 4.83691H6.3487C5.18051 4.83691 4.23242 5.78501 4.23242 6.95319C4.23242 8.12138 5.18051 9.06947 6.3487 9.06947C6.51558 9.06947 6.65103 9.20491 6.65103 9.3718Z",
  stroke: "#F1F3F6",
  strokeWidth: 0.3
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M7.25585 5.74421V4.53491C7.25585 4.03426 6.84952 3.62793 6.34887 3.62793C5.84822 3.62793 5.44189 4.03426 5.44189 4.53491V5.74421C5.44189 6.24486 5.84822 6.65119 6.34887 6.65119C6.84952 6.65119 7.25585 6.24486 7.25585 5.74421Z",
  stroke: "#F1F3F6",
  strokeWidth: 0.3
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M7.25585 11.7911V10.5818C7.25585 10.0811 6.84952 9.6748 6.34887 9.6748C5.84822 9.6748 5.44189 10.0811 5.44189 10.5818V11.7911C5.44189 12.2917 5.84822 12.6981 6.34887 12.6981C6.84952 12.6981 7.25585 12.2917 7.25585 11.7911Z",
  stroke: "#F1F3F6",
  strokeWidth: 0.3
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M11.1862 6.65087H16.628C17.1287 6.65087 17.535 6.24454 17.535 5.74389C17.535 5.24324 17.1287 4.83691 16.628 4.83691H11.1862C10.6855 4.83691 10.2792 5.24324 10.2792 5.74389C10.2792 6.24454 10.6855 6.65087 11.1862 6.65087Z",
  stroke: "#F1F3F6",
  strokeWidth: 0.3
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M11.1862 11.4888H16.628C17.1287 11.4888 17.535 11.0824 17.535 10.5818C17.535 10.0811 17.1287 9.6748 16.628 9.6748H11.1862C10.6855 9.6748 10.2792 10.0811 10.2792 10.5818C10.2792 11.0824 10.6855 11.4888 11.1862 11.4888Z",
  stroke: "#F1F3F6",
  strokeWidth: 0.3
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M4.53491 16.3257H16.6279C17.1286 16.3257 17.5349 15.9193 17.5349 15.4187C17.5349 14.918 17.1286 14.5117 16.6279 14.5117H4.53491C4.03426 14.5117 3.62793 14.918 3.62793 15.4187C3.62793 15.9193 4.03426 16.3257 4.53491 16.3257Z",
  stroke: "#F1F3F6",
  strokeWidth: 0.3
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M4.53491 21.1626H16.6279C17.1286 21.1626 17.5349 20.7563 17.5349 20.2556C17.5349 19.755 17.1286 19.3486 16.6279 19.3486H4.53491C4.03426 19.3486 3.62793 19.755 3.62793 20.2556C3.62793 20.7563 4.03426 21.1626 4.53491 21.1626Z",
  stroke: "#F1F3F6",
  strokeWidth: 0.3
});

const SvgAccStmt = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 26,
    viewBox: "0 0 22 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAccStmt, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/acc_stmt.2ddeb1c2.svg";
export { ForwardRef as ReactComponent };